import { LocationPickerModeEnum } from './location-picker.enum'

export const hasMinimumLength = (value: string): boolean =>
  !!value && value.length > 2

interface getListMessageParams {
  isLoading: boolean
  hasResults: boolean
  hasLength?: boolean
  searchQuery?: string
}

export const getListMessage = ({
  isLoading,
  hasResults,
  hasLength = true,
  searchQuery,
}: getListMessageParams): string => {
  if (isLoading) {
    return 'Chargement...'
  }
  if (!hasLength) {
    return 'Veuillez entrer au moins 3 caractères'
  }
  if (searchQuery && searchQuery.length > 0 && !hasResults) {
    return 'Aucun résultat'
  }
  return ''
}

export const getLocationPickerClassNameByEnum = (
  locationPickerModeEnum: LocationPickerModeEnum,
): string => {
  switch (locationPickerModeEnum) {
    case LocationPickerModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
